export const TableWidths = [
  "w-[2.2225313%] max-w-[32px]",
  "w-[4.86787204%] max-w-[70px]",
  "w-[6.95410292%] max-w-[100px]",
  "w-[11.40472879%] max-w-[164px] min-w-[100px]",
  "w-[11.40472879%] max-w-[164px] min-w-[100px]",
  "w-[10.29207232%] max-w-[148px] min-w-[148px]",
  "w-[10.29207232%] max-w-[148px] min-w-[148px]",
  "w-[6.39777469%] max-w-[92px]",
  "w-[9.73574409%] max-w-[140px]",
  "w-[12.72600834%] max-w-[183px]",
  "min-w-[64px] w-auto",
];
